import { createPortal } from 'react-dom'

import { Modal } from 'react-bootstrap'
import ImageUploader1 from 'Presentation/Components/Uploader/Images/ImageUploader1'
import FormGenerator from 'Presentation/Components/Form/FormGenerator'

import useViewModel from './ViewModel'

const FormUserModal: React.FC = () => {
	const {
		open,
		formType,
		formState,
		onChange,
		passwordState,
		handleSubmit,
		handleClose,
		error,
		isSubmitting,
	} = useViewModel()

	const modalsRoot = document.getElementById('root-modals') || document.body

	return createPortal(
		<Modal
			size="sm"
			id="kt_modal_buyer_billing_address_modal"
			tabIndex={-1}
			aria-hidden="true"
			dialogClassName="modal-dialog modal-dialog-centered mw-600px"
			show={open}
			onHide={handleClose}
			backdrop={true}>
			<div className="modal-content">
				<div className="modal-body py-lg-10 px-lg-10 min-h-500px">
					<h1 className="text-kumopack-grey-900 text-center">
						{formType === 'add' ? 'เพิ่มผู้ใช้งานใหม่' : 'แก้ไขผู้ใช้งาน'}
					</h1>
					{/* <div className="text-kumupack-grey-600 text-center">
						ทุกความคิดเห็นของท่านมีผลต่อการปรับปรุงระบบให้ดีิยิ่งขึ้น
					</div> */}

					<div className="mt-10 card border border-kumopack-grey-200">
						<div className="card-body">
							<label className="mb-0 form-label">Profile Picture</label>

							<ImageUploader1
								formKey="supplier-user-form-profile-picture"
								image={formState.pictureProfilePath}
								changeImage={img => onChange('pictureProfilePath', img)}
							/>

							<FormGenerator
								formKey="fullnameTh"
								inputType="plain"
								label="ขื่อ-นามสกุล"
								additionalClassName="form-control-sm"
								containerClassName="mb-5"
								isHorizontal={false}
								value={formState.fullnameTh}
								onChange={e => onChange('fullnameTh', e.target.value)}
								isShowValid={!!error?.fullnameTh}
								additionalComInput={
									error?.fullnameTh ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{error.fullnameTh}</div>
										</div>
									) : undefined
								}
							/>

							<FormGenerator
								formKey="fullnameEn"
								inputType="plain"
								label="Name - Surname"
								additionalClassName="form-control-sm"
								containerClassName="mb-5"
								isHorizontal={false}
								value={formState.fullnameEn}
								onChange={e => onChange('fullnameEn', e.target.value)}
								isShowValid={!!error?.fullnameEn}
								additionalComInput={
									error?.fullnameEn ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{error.fullnameEn}</div>
										</div>
									) : undefined
								}
							/>

							<FormGenerator
								formKey="email"
								inputType="plain"
								label="อีเมล"
								additionalClassName="form-control-sm"
								containerClassName="mb-5"
								isHorizontal={false}
								value={formState.email}
								onChange={e => onChange('email', e.target.value)}
								isShowValid={!!error?.email}
								additionalComInput={
									error?.email ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{error.email}</div>
										</div>
									) : undefined
								}
							/>

							<FormGenerator
								formKey="roleTitle"
								inputType="plain"
								label="Role"
								additionalClassName="form-control-sm"
								containerClassName="mb-5"
								isHorizontal={false}
								value={formState.roleTitle}
								onChange={e => onChange('roleTitle', e.target.value)}
								isShowValid={!!error?.roleTitle}
								additionalComInput={
									error?.roleTitle ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{error.roleTitle}</div>
										</div>
									) : undefined
								}
							/>

							{formType === 'edit' && (
								<FormGenerator
									formKey="oldPassword"
									inputType="plain"
									type="password"
									label="รหัสผ่านเก่า"
									additionalClassName="form-control-sm"
									containerClassName="mb-5"
									isHorizontal={false}
									limitCharacter={100}
									value={passwordState.oldPassword}
									onChange={e => onChange('oldPassword', e.target.value)}
								/>
							)}

							<FormGenerator
								formKey="newPassword"
								inputType="plain"
								type="password"
								label="รหัสผ่านใหม่"
								additionalClassName="form-control-sm"
								containerClassName="mb-5"
								isHorizontal={false}
								limitCharacter={100}
								value={passwordState.newPassword}
								onChange={e => onChange('newPassword', e.target.value)}
							/>
						</div>

						<div className="card-footer">
							<div className="row">
								<div className="col-12 col-xl-6">
									<button
										disabled={isSubmitting}
										className="btn btn-sm white-button text-kumopack-grey-700 fw-bold w-100"
										onClick={handleClose}>
										ยกเลิก
									</button>
								</div>
								<div className="col-12 col-xl-6">
									<button
										disabled={isSubmitting}
										className="btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white fw-bold w-100"
										onClick={handleSubmit}>
										ยืนยัน{' '}
										<img src="/media/icons/kumopack/chevron-right.svg" alt="White Chevron Right" />
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>,
		modalsRoot
	)
}

export default FormUserModal
